var React = require('react');

function Menu24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"State=Default, Color=Black","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"},[React.createElement("path",{"id":"Vector 172","d":"M1 8h22","key":0}),React.createElement("path",{"id":"Vector 173","d":"M1 16h22","key":1})]));
}

Menu24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Menu24x24;

Menu24x24.default = Menu24x24;
